

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const CHANGE_THEME = 'CHANGE_THEME'

// 更新 菜单
export const UPDATE_MENUS = 'UPDATE_MENUS'

// 更新 token
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
// 更新 用户信息
export const UPDATE_USERINFO = 'UPDATE_USERINFO'
